var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "width": "800"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', [_vm._v("mdi-eye")]), _vm._v(" Adicionar um novo tipo de termo ")], 1)]), _c('div', {
    staticClass: "container dialog"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-7"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Tipo de Termo*",
      "outlined": "",
      "dense": "",
      "rules": [function (v) {
        return v && v.length > 0 || 'Campo obrigatório';
      }]
    },
    model: {
      value: _vm.novoTipoTermo,
      callback: function ($$v) {
        _vm.novoTipoTermo = $$v;
      },
      expression: "novoTipoTermo"
    }
  })], 1)], 1)], 1), _c('sigfoco-buttons', {
    attrs: {
      "actionText": 'Confirmar'
    },
    on: {
      "click": _vm.confirmar,
      "cancel": _vm.cancelar
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }